import { logger } from '../../common/logger';
import { isClient } from '../../common/utils';

export const getLocalStorageValue = <T>(key: string) => {
  if (isClient()) {
    const storedItem = window.localStorage.getItem(key);

    if (storedItem !== null) {
      try {
        return JSON.parse(storedItem) as T;
      } catch (e) {
        logger.error(`Failed retreiving localStorage item with key: ${key}`, e);
      }
    }
  }
};

export const setLocalStorageValue = <T>(key: string, value: T) => {
  try {
    if (isClient()) {
      window.localStorage.setItem(key, JSON.stringify(value));
    }
  } catch (e) {
    logger.error(`Failed to update localStorage with key: ${key}`, e);
  }
};
